import React from "react";
import CardItem from "./CardItem";
import "./Cards.css";

function Cards() {
  return (
    <div className="cards">
      <h1>Check out these Epic Destinations!</h1>
      <div className="cards__container">
        <div className="cards__wrapper">
          <ul className="cards__items">
            <CardItem
              src="images/img-1.jpg"
              text="With a summit scraping the sky at 11,053 feet, Mammoth Mountain has the highest lift-served skiable terrain in California, not to mention iconic Sierra vistas, the famous Unbound Terrain Parks and a legendary snowpack that keeps the season going all the way into July."
              label="Mammoth Mountain,United States"
              path="/destinations"
            />
            <CardItem
              src="images/img-2.jpg"
              text="Swiss hospitality and Italian lifestyle seamlessly merge together on the slopes of Zermatt Matterhorn. This unique European winter escape offers extensive skiing and riding with more than 220 miles (360 km) of perfect pistes and the highest lift-served terrain on the continent"
              label="Zermatt, Switzerland"
              path="/destinations"
            />
          </ul>
          <ul className="cards__items">
            <CardItem
              src="images/img-1.jpg"
              text="With a summit scraping the sky at 11,053 feet, Mammoth Mountain has the highest lift-served skiable terrain in California, not to mention iconic Sierra vistas, the famous Unbound Terrain Parks and a legendary snowpack that keeps the season going all the way into July."
              label="Mammoths Mountain, United States"
              path="/destinations"
            />
            <CardItem
              src="images/img-2.jpg"
              text="Swiss hospitality and Italian lifestyle seamlessly merge together on the slopes of Zermatt Matterhorn. This unique European winter escape offers extensive skiing and riding with more than 220 miles (360 km) of perfect pistes and the highest lift-served terrain on the continent"
              label="Zermatt, Switzerland"
              path="/destinations"
            />
            <CardItem
              src="images/img-3.jpg"
              text="Steamboat is home to Champagne Powder® snow, legendary trees, top family programs and has produced more winter Olympians than any other town in the US."
              label="Steamboat, United States"
              path="/destinations"
            />
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Cards;
